'use client';
import Script from 'next/script';
import constants from '../constants';

const GoogleAnalytics = () => {
  return (
    <div className="googleAnalytics">
      <Script
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtag/js?id=${constants.GA_TRACKING_ID}`}
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
          }
          gtag('js', new Date());
          gtag('config', '${constants.GA_TRACKING_ID}', {
            page_path: window.location.pathname,
          });
        `}
      </Script>
    </div>
  );
};

export default GoogleAnalytics;
